import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import LetsBuildTogether from "./sections/LetsBuildTogether";
import RegionalPresence from "./sections/RegionalPresence";
import SecurityIntelligenceFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <LetsBuildTogether />
      <RegionalPresence />
      <SecurityIntelligenceFooter />
    </div>;
}